import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { OA_QUERY_FILTER_MAPPINGS } from "../../oa-query-schema";
import { syncFiltersWithSearch } from "@/utils/urlFilterParams";

export default function useOASyncFilterQueryState(appliedFiltersState) {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (!Array.isArray(appliedFiltersState)) {
			return;
		}

		const nextSearch = syncFiltersWithSearch(location.search, appliedFiltersState, OA_QUERY_FILTER_MAPPINGS);
		const currentSearch = location.search.startsWith("?") ? location.search.slice(1) : location.search;

		if (nextSearch === currentSearch) {
			return;
		}

		navigate(
			{
				pathname: location.pathname,
				search: nextSearch ? `?${nextSearch}` : "",
				hash: location.hash,
			},
			{ replace: true },
		);
	}, [appliedFiltersState, location.hash, location.pathname, location.search, navigate]);
}
